// src/theme/CustomThemeProvider.jsx
import React from "react";
import { ThemeProvider, createTheme } from "@mui/material/styles";
import { CssBaseline } from "@mui/material";
import { useRecoilValue } from "recoil";
import themeAtom from "../store/themeAtom";

const themes = {
  light: {
    palette: {
      mode: "light",
    },
  },
  dark: {
    palette: {
      mode: "dark",
    },
  },
};

function CustomThemeProvider({ children }) {
  const currentTheme = useRecoilValue(themeAtom);
  const muiTheme = createTheme(themes[currentTheme]);

  return (
    <ThemeProvider theme={muiTheme}>
      <CssBaseline />
      {children}
    </ThemeProvider>
  );
}

export default CustomThemeProvider;
